/**
 * @name JobChange
 * @description Componente de cambio de puesto en configuración de perfil
 * @author Alexis Becerra
 */

import React, { Component } from 'react';
import i18n from 'i18next';
import { Formik } from 'formik';
import styled from 'styled-components';
import { trackPromise } from 'react-promise-tracker';


import { DataGrid, LoadingWrapper } from '@components';
import { Environment } from '@config';
import { JobService, ResponseHandlerService, JobChangeService, EmployeeService, NotificationsService } from '@services';
import { Avatar, MUI, Typography } from '@styles';

class JobChange extends Component {
  constructor(props) {
    super(props);
    this.employee = JSON.parse(localStorage.getItem('ls.infoUsuario')).Empleado;

    this.state = {
      employeeId: this.employee.IdEmpleado,
      gridConfig: {
        rows: [],
        columns: [
          { id: 'Nombre', label: i18n.t('GenericMessages.name'), visible: true, filter: null },
          { id: 'PuestoActual', label: i18n.t('Request.actualJob'), visible: true, filter: null },
          { id: 'Puesto', label: i18n.t('Request.requiredJob'), visible: true, filter: null },
          { id: 'Autorizado', label: i18n.t('GenericMessages.status'), visible: true, filter: 'YesNoFilter' },
        ],
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canSelect: false,
      },
      catalogJob: [],
      IdPuesto: null,
      filters: {
        job: {
          IdPuesto: null,
          Nombre: null
        }
      },
      jobResp: {
        IdPuesto: null,
        Nombre: null
      },
      photo: '',
      name: '',
      job: '',
      area: '',
    };
  }


  componentDidMount() {
    const { employeeId } = this.state;
    this.getJobs();
    this.getData();
    this.getPendingRequest(employeeId);
    this.loadUserInfo(employeeId);
  }

  // Obtiene las solicitudes de cambio de puesto
  getData = () => {
    JobChangeService.getData()
      .then((response) => {
        this.setState({
          IdPuesto: response[0].IdPuesto
        });
      }).catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  // Consulta las solicitudes pendientes de un empleado
  getPendingRequest = (employee) => {
    if (employee) {

      JobChangeService.getDataPending(employee)
        .then((response) => {
          const { gridConfig } = this.state;
          gridConfig.rows = response;
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          const { gridConfig } = this.state;
          gridConfig.rows = [];
          this.setState((prevState) => ({
            gridConfig: { ...prevState.gridConfig, gridConfig },
          }));
        });
    }
  }


  // Obtiene la lista de puestos de una empresa
  getJobs = () => {
    JobService.get({ filter: {} })
      .then((response) => {
        this.setState({ catalogJob: response });
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  // Actualiza los filtros del filtro
  updateFilters = ({ job }) => {
    this.setState({ filters: { job } });
  }

  // Obtiene la información del empleado
  loadUserInfo = (employeeId) => {
    EmployeeService.getOne(employeeId)
      .then((response) => {
        this.setState({
          photo: response.Foto || 'https://assets.talentry.io/icons/profile/TAL_Avatar.png',
          name: response.Nombre,
          job: response.Puesto,
          area: response.Area,
        });
      })
      .catch(() => {
        // TODO: Añadir Snackbar 
        // console.log('No fue posible cargar la información de empleado');
      });
  }

  // Registra una solicitud de puesto
  post = (values, setSubmitting) => {
    let request = {
      IdPuesto: this.state.filters.job.IdPuesto
    };

    let notificationToSend = {
      IdTipoNotificacion: 132,
      IdEmpleado: this.employee.IdReporta,
      IdAmbiente: Environment.getCurrent().environmentId,
      URL: '#/configuraperfil',
      Parametros: JSON.stringify({ Tab: 9 })
    };

    JobChangeService.post(request)
      .then((response) => {
        if (notificationToSend.IdEmpleado !== this.state.employeeId) {
          NotificationsService.post(notificationToSend)
            .then(() => {
              ResponseHandlerService.success(response);
              setSubmitting(false);
              window.location.reload();
            })
            .catch((error) => {
              ResponseHandlerService.error(error);
            });
        }
        else {
          ResponseHandlerService.success(response);
          setSubmitting(false);
          window.location.reload();
        }
      }).catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  render() {
    const {
      catalogJob,
      filters,
      IdPuesto,
      photo,
      name,
      job,
      area,
      gridConfig
    } = this.state;

    return (
      <>
        <FilterWrapper>
          <Formik
            enableReinitialize
            initialValues={{ IdPuesto, catalogJob }}
            onSubmit={(values, { setSubmitting }) => {
              this.post(values, setSubmitting);
            }}
          >

            {(props) => {
              return (
                <>
                  <MUI.Grid container>
                    {IdPuesto ? null :
                      <>
                        <BoxRow>
                          <MUI.Grid container direction="row" alignItems="center">

                            <MUI.Grid item xs={4} sm>
                              <MUI.Box
                                display="flex"
                                alignItems="center"
                                padding="8px"
                              >
                                <MUI.Box>
                                  <Avatar
                                    size="sm"
                                    src={photo}
                                  />
                                </MUI.Box>
                                <MUI.Box
                                  display="flex"
                                  width="100%"
                                  paddingLeft="16px"
                                >
                                  <MUI.TextField
                                    label={i18n.t('GenericMessages.name')}
                                    type="text"
                                    disabled={true}
                                    value={name}
                                  />
                                </MUI.Box>
                              </MUI.Box>
                            </MUI.Grid>

                            <MUI.Grid item xs={4} sm >
                              <MUI.Box padding="8px">
                                <MUI.TextField
                                  label={i18n.t('GenericMessages.job')}
                                  type="text"
                                  disabled={true}
                                  value={job}
                                />
                              </MUI.Box>
                            </MUI.Grid>
                            <MUI.Grid item xs={4} sm >
                              <MUI.Box padding="8px">
                                <MUI.TextField
                                  label={i18n.t('GenericMessages.area')}
                                  type="text"
                                  disabled={true}
                                  value={area}
                                />
                              </MUI.Box>
                            </MUI.Grid>

                          </MUI.Grid>
                        </BoxRow>
                      </>}
                    {IdPuesto ? (
                      <MUI.Grid item xs={12}>
                        <DataGrid
                          columns={gridConfig.columns}
                          rows={gridConfig.rows}
                          isPaginated={true}
                        />
                      </MUI.Grid>
                    ) : (
                      <>
                        <BoxRow>
                          <MUI.Grid item md={4} sm={6} xs={12}></MUI.Grid>
                          <MUI.Grid item md={4} sm={6} xs={12}>
                            <Typography.H6>{i18n.t('Request.selectnewJob')}</Typography.H6>
                          </MUI.Grid>
                          <MUI.Grid item md={3} sm={6} xs={12}></MUI.Grid>
                        </BoxRow>
                        <BoxRow>
                          <MUI.Grid item md={4} sm={6} xs={12}></MUI.Grid>
                          {/* Selector de puesto */}
                          <MUI.Grid item md={4} sm={6} xs={12}>
                            <MUI.Autocomplete
                              label={i18n.t('GenericMessages.job')}
                              searchList={catalogJob}
                              searchBy="Puesto"
                              value={filters.job}
                              disabled={IdPuesto}
                              onChange={(newJob) => this.updateFilters({
                                job: newJob
                              })}
                            />
                          </MUI.Grid>
                          <MUI.Grid item md={4} sm={6} xs={12}></MUI.Grid>
                        </BoxRow>
                      </>
                    )}
                  </MUI.Grid>

                  {/* Botones */}
                  {IdPuesto ? null :
                    <>
                      <BoxActions>
                        <MUI.ButtonCTA
                          type="button"
                          color="primary"
                          disabled={!props.isValid || props.isSubmitting || filters.job === null || filters.job.IdPuesto === null}
                          onClick={props.handleSubmit}
                        >
                          {i18n.t('DialogConfirm.save')}
                        </MUI.ButtonCTA>
                      </BoxActions>
                    </>}
                </>
              );
            }}
          </Formik>
        </FilterWrapper>
      </>
    );
  }
}

// *************************************
// STYLED COMPONENTS
// *************************************

const BoxActions = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding: 8px;
`;

const FilterWrapper = styled.section`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding: 8px;
  border: 1px solid ${(props) => props.theme.colors.greyLight};
  border-radius: 6px;
  box-shadow: ${(props) => props.theme.shadows.depth2};
`;

const BoxRow = styled.div`
  display: flex;
  width: 100%;
  padding: 3px;
  text-align: center;
`;

export default JobChange;
